module.exports = __webpack_public_path__ + "img/public-welfare-assistance.92b7b1d8.png";